<mat-card class="profile-container">
  <div class="profile-avatar">
    <img [src]="imagePreview || 'assets/default-profile.jpeg'" alt="Profile Image" class="profile-image" />
    <div class="profile-info">
      <h3>{{ username }}</h3>
      <p>{{ email }}</p>
    </div>
  </div>

  <mat-card-actions>
    <button mat-stroked-button (click)="openAccountSettings()">
      <mat-icon>settings</mat-icon> Minha Conta
    </button>

    <button mat-stroked-button color="warn" (click)="logout()">
      <mat-icon>exit_to_app</mat-icon> Logout
    </button>
  </mat-card-actions>
</mat-card>